<template>
  <div id="home" class="min-h-screen pb-20" style="background: #f5f5f5;">

    <!-- 顶部搜索栏 -->
    <div class="sticky top-0 z-50" style="background: linear-gradient(135deg, #e53e3e, #c53030);">
      <div class="flex items-center px-3 py-2.5 space-x-2.5">
        <span class="text-white font-bold text-lg flex-shrink-0">金怡佳</span>
        <div class="flex-1 flex items-center bg-white rounded-full px-3 py-1.5">
          <svg class="w-4 h-4 text-red-400 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
          </svg>
          <input
              v-model="value"
              type="text"
              placeholder="搜索商品名称 / 品牌"
              class="bg-transparent text-sm text-gray-700 placeholder-gray-400 w-full outline-none"
              @keyup.enter="onSearch"
          />
          <div
              class="flex-shrink-0 text-white text-xs font-medium px-3 py-1 rounded-full ml-2"
              style="background: linear-gradient(135deg, #e53e3e, #c53030);"
              @click="onSearch"
          >搜索</div>
        </div>
      </div>
    </div>

    <!-- 轮播图 -->
    <div class="w-full" style="background: linear-gradient(180deg, #c53030 0%, #f5f5f5 50%);">
      <div class="px-3 pt-1 pb-2">
        <van-swipe :autoplay="3000" class="banner-swipe" indicator-color="#fff">
          <van-swipe-item v-for="(banner, index) in banners" :key="index">
            <div class="rounded-xl overflow-hidden">
              <img
                  :src="banner.banner"
                  class="w-full object-cover"
                  style="height: 160px;"
                  @click="goShopping(banner.id)"
              />
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <!-- 服务标签 -->
    <div class="bg-white mx-3 mt-2 rounded-t-xl px-2 pt-2.5 pb-2 flex items-center justify-around border-b border-gray-100">
      <div class="flex items-center text-xs text-gray-600">
        <svg class="w-3.5 h-3.5 mr-1 text-red-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        <span>全品类供货</span>
      </div>
      <div class="flex items-center text-xs text-gray-600">
        <svg class="w-3.5 h-3.5 mr-1 text-red-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
        <span>360度服务</span>
      </div>
      <div class="flex items-center text-xs text-gray-600">
        <svg class="w-3.5 h-3.5 mr-1 text-red-500" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
        <span>闪电配送</span>
      </div>
    </div>

    <!-- 分类导航 -->
    <div class="bg-white mx-3 rounded-b-xl px-2 pt-2 pb-3">
      <div class="grid grid-cols-5 gap-y-4">
        <div
            v-for="cat in categories"
            :key="cat.id"
            class="flex flex-col items-center active:opacity-60"
            @click="onCategoryClick(cat)"
        >
          <div
              class="w-12 h-12 rounded-xl flex items-center justify-center mb-1.5"
              style="background: var(--primary);"
          >
            <span class="text-xl font-black text-white">{{ cat.word }}</span>
          </div>
          <span class="text-xs text-gray-700">{{ cat.name }}</span>
        </div>
      </div>
    </div>

    <!-- 精选推荐广告图 2:1:1 -->
    <div class="px-3 pt-3 pb-1" v-if="fixedAds.length >= 3">
      <div class="grid grid-cols-4 gap-2">
        <div
            class="col-span-2 rounded-xl overflow-hidden active:opacity-80"
            style="box-shadow: 0 1px 6px rgba(0,0,0,0.06);"
            @click="goShopping(fixedAds[0].id)"
        >
          <img :src="fixedAds[0].picture" class="w-full object-cover" style="aspect-ratio: 16/9;" />
        </div>
        <div class="col-span-1 flex flex-col gap-2">
          <div
              class="flex-1 rounded-xl overflow-hidden active:opacity-80"
              style="box-shadow: 0 1px 6px rgba(0,0,0,0.06);"
              @click="goShopping(fixedAds[1].id)"
          >
            <img :src="fixedAds[1].picture" class="w-full h-full object-cover" />
          </div>
        </div>
        <div class="col-span-1 flex flex-col gap-2">
          <div
              class="flex-1 rounded-xl overflow-hidden active:opacity-80"
              style="box-shadow: 0 1px 6px rgba(0,0,0,0.06);"
              @click="goShopping(fixedAds[2].id)"
          >
            <img :src="fixedAds[2].picture" class="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </div>

    <!-- 热销 / 特价 / 好评 标签栏 -->
    <div class="mx-3 mt-3 rounded-xl overflow-hidden bg-white" style="box-shadow: 0 1px 8px rgba(0,0,0,0.04);">
      <van-tabs v-model="active" swipeable class="product-tabs">
        <van-tab
            v-for="(item, index) in showBar"
            :title="item.label"
            :key="index"
        >
          <div class="p-2.5">
            <div class="grid grid-cols-2 gap-2">
              <div
                  v-for="(product, idx) in item.data"
                  :key="idx"
                  v-if="product.price"
                  class="rounded-xl overflow-hidden bg-white active:opacity-80"
                  style="border: 1px solid #f0f0f0;"
                  @click="goShopping(product.id)"
              >
                <div class="relative bg-gray-50">
                  <img
                      :src="product.picture"
                      class="w-full object-contain"
                      style="height: 140px;"
                  />
                  <span
                      class="absolute top-2 left-2 text-white text-xs px-2 py-0.5 rounded-sm font-medium"
                      :style="'background:' + item.tagColor"
                  >{{ item.tag }}</span>
                </div>
                <div class="p-2.5">
                  <p class="text-xs text-gray-800 line-clamp-2 leading-normal" style="min-height: 2.4em;">
                    {{ product.title }}
                  </p>
                  <div class="mt-1.5 flex items-baseline">
                    <span class="text-red-500 text-xs font-bold">¥</span>
                    <span class="text-red-500 text-lg font-bold leading-none">{{ formatPrice(product.price) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 楼层商品 -->
    <div v-for="floor in floors" :key="floor.id + '' + floor.floorName" class="mt-3">
      <!-- 楼层标题 -->
      <div class="flex items-center justify-between px-4 py-3">
        <div class="flex items-center">
          <div class="w-1 h-4 rounded-full mr-2" style="background: var(--primary);"></div>
          <span class="text-base font-bold text-gray-900">{{ floor.floorName }}</span>
        </div>
        <div class="flex items-center text-xs text-gray-400">
          <span>{{ floor.rightTag || '更多' }}</span>
          <svg class="w-3 h-3 ml-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </div>
      </div>

      <!-- 楼层广告图 -->
      <div v-if="floor.floorAdvertVOS && floor.floorAdvertVOS.length" class="px-3 pb-2">
        <div class="grid gap-2" :class="getGridCols(floor.floorAdvertVOS)">
          <div
              v-for="(ad, adIdx) in floor.floorAdvertVOS"
              :key="floor.id + '-ad-' + adIdx"
              class="rounded-lg overflow-hidden active:opacity-80"
              @click="goShopping(ad.id)"
          >
            <img :src="ad.imageUrl" class="w-full object-cover" style="aspect-ratio: 3/4;" />
          </div>
        </div>
      </div>

      <!-- 楼层商品网格 -->
      <div class="px-3 pb-2">
        <div class="grid gap-2.5" :class="getGridCols(floor.floorGoodsVOS)">
          <div
              v-for="(item, index) in getValidGoods(floor.floorGoodsVOS)"
              :key="'g-' + index"
              class="rounded-xl overflow-hidden bg-white active:opacity-80"
              style="border: 1px solid #f0f0f0; box-shadow: 0 1px 6px rgba(0,0,0,0.04);"
              @click="goShopping(item.id)"
          >
            <img :src="item.imageUrl" class="w-full object-contain bg-gray-50" style="height: 120px;" />
            <div class="px-2 py-2">
              <p class="text-sm text-gray-800 truncate">{{ item.goodsName }}</p>
              <div class="flex items-baseline mt-1">
                <span class="text-red-500 text-xs font-bold">¥</span>
                <span class="text-red-500 text-base font-bold">{{ formatPrice(item.price) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部留白 -->
    <div class="h-4"></div>

    <!-- 激活认证弹窗 -->
    <van-dialog
        v-model="showDialog"
        :title="dialog.title"
        :confirm-button-text="dialog.confirmText"
        :show-confirm-button="dialog.showConfirm"
        :cancel-button-text="dialog.cancelText"
        :show-cancel-button="dialog.showCancel"
        :beforeClose="(action, done) => { done(false) }"
        @confirm="next"
        @cancel="pre"
    >
      <div class="p-4">
        <div v-if="step === 1" class="space-y-4">
          <img src="../../assets/images/downloadThePrint.jpg" alt="" class="w-full rounded-lg" />
          <div class="flex items-start space-x-2">
            <van-checkbox v-model="registerClick" class="mt-0.5"></van-checkbox>
            <span class="text-sm text-gray-600">
              请阅读并同意
              <a href="javascript:void(0);" @click="agreeDialog" class="text-red-500 font-medium">《用户注册协议》</a>
            </span>
          </div>
        </div>

        <div v-if="step === 2" class="space-y-3">
          <van-field v-model="newMobile" center clearable placeholder="请输入手机号">
            <template #button>
              <van-button size="small" type="danger" @click="getVerification" v-if="!showCountdown" round>获取验证码</van-button>
              <van-button size="small" type="danger" v-else disabled round>({{ countdownNum }}s)后获取</van-button>
            </template>
          </van-field>
          <van-field placeholder="请输入验证码" v-model="verificationCode" />
          <div class="bg-orange-50 p-3 rounded-lg">
            <p class="text-xs text-orange-600 leading-relaxed">
              请填写下单支付手机号,该手机号用于登录平台、支付验证码接收。请确保方便及时且有效,一经绑定无法修改,请慎重填写。
            </p>
          </div>
        </div>

        <div v-if="step === 3" class="space-y-3">
          <van-field placeholder="请输入密码" v-model="password" type="password" @blur="validatePassword" />
          <van-field placeholder="请再次输入密码" v-model="confirmPassword" type="password" @blur="validateConfirmPassword" />
          <div class="bg-orange-50 p-3 rounded-lg">
            <p class="text-xs text-orange-600 leading-relaxed">
              为了避免账户因密码泄露或他人使用造成的不良后果及影响,首次登录请先修改密码。
              修改后可使用新密码登录进行订货,否则将不能使用本平台的任何功能。
            </p>
          </div>
        </div>
      </div>
    </van-dialog>

    <!-- 公告弹窗 -->
    <van-dialog
        v-model="notice"
        :title="noticeInfo.title"
        confirmButtonText="我知道了"
        :message="noticeInfo.description"
    />
  </div>
</template>

<script>
import {
  listAds,
  updatePhonePwd,
  determineMobile,
  getVerificationCodeByMobile,
  submitMobilePwdVer,
} from "../../api/advert";
import { popNotice } from "../../api/notice";
import { Toast, Dialog } from "vant";

export default {
  data() {
    return {
      value: "",
      active: 0,
      banners: [],
      fixedAds: [],
      floors: [],
      showBar: [],
      categories: [
        { id: 238, name: "超值购", word: "多" },
        { id: 141, name: "手机", word: "快" },
        { id: 142, name: "生态普品", word: "好" },
        { id: 164, name: "智慧屏", word: "省" },
        { id: 143, name: "配件", word: "值" },
        { id: 144, name: "融合产品", word: "全" },
        { id: 146, name: "家电", word: "品" },
        { id: -1, name: "智能穿戴", word: "类" },
        { id: -2, name: "AI眼镜", word: "供" },
        { id: 0, name: "个人中心", word: "货" },
      ],

      showDialog: false,
      step: 1,
      dialog: {
        title: "激活认证",
        showConfirm: true,
        confirmText: "下一步",
        showCancel: true,
        cancelText: "复制下载链接",
      },
      registerClick: false,
      isClick: false,
      newMobile: "",
      verificationCode: "",
      password: "",
      confirmPassword: "",
      showCountdown: false,
      countdownNum: 0,

      notice: false,
      noticeInfo: { title: "", description: "" },
    };
  },

  mounted() {
    this.loadData();
    this.noticeState();
  },

  methods: {
    loadData() {
      listAds((d) => {
        if (!d) return;
        this.banners = d.banners.banners || [];
        this.fixedAds = d.advertisement.pictures || [];
        this.floors = d.floor || [];
        if (d.categories && d.categories.length) {
          this.categories = d.categories;
        }
        this.showBar = [];
        if (d.popular) {
          if (d.popular.sellWell && d.popular.sellWell.length) {
            this.showBar.push({ label: "热销爆款", tag: "热销", tagColor: "#e53e3e", data: d.popular.sellWell });
          }
          if (d.popular.specialPrice && d.popular.specialPrice.length) {
            this.showBar.push({ label: "限时特价", tag: "特价", tagColor: "#ea580c", data: d.popular.specialPrice });
          }
          if (d.popular.favorableComment && d.popular.favorableComment.length) {
            this.showBar.push({ label: "德信内购", tag: "好评", tagColor: "#16a34a", data: d.popular.favorableComment });
          }
        }
      });
    },

    formatPrice(price) {
      if (!price) return "0";
      var n = Number(price);
      if (n >= 100000000) return "询价";
      return n % 1 === 0 ? n.toString() : n.toFixed(2);
    },

    getGridCols(items) {
      if (!items || !items.length) return "grid-cols-2";
      var span = items[0].spanSize;
      if (span === 4) return "grid-cols-2";
      if (span === 6) return "grid-cols-2";
      if (span === 12) return "grid-cols-1";
      return "grid-cols-" + Math.floor(12 / span);
    },

    getValidGoods(goods) {
      if (!goods) return [];
      return goods.filter(function (g) { return g.id; });
    },

    onSearch() {
      if (!this.value.trim()) return;
      this.$router.push({ path: "search", query: { keyword: this.value } });
    },

    onCategoryClick(cat) {
      if(cat.id==0){
        this.$router.push("/user");
      } else if (!cat.id) {
        this.$router.push("/classification");
      } else {
        this.$router.push({ path: "/classification", query: { categoryId: cat.id } });
      }
    },

    goShopping(id) {
      if (!id) return;
      this.$router.push("/goods/" + id);
    },

    noticeState() {
      popNotice().then((res) => {
        if (res.data && res.data.id) {
          this.notice = true;
          this.noticeInfo = res.data;
        }
      });
    },

    getUser() {
      updatePhonePwd(
          (d) => { this.showDialog = !!d; },
          () => { Toast("不需要修改信息!"); }
      );
    },

    getVerification() {
      this.newMobile = this.newMobile ? this.newMobile.replace(/ /g, "") : undefined;
      if (!this.newMobile || this.newMobile.length !== 11) {
        Toast("请输入正确的手机号码!");
        return;
      }
      determineMobile(
          this.newMobile,
          (d) => {
            if (d.success) {
              this.countdown();
              this.getVerificationCode(this.newMobile);
            } else {
              Toast(d.msg);
            }
          },
          () => Toast.fail("发送出现异常")
      );
    },

    getVerificationCode(newMobile) {
      getVerificationCodeByMobile(
          newMobile,
          () => Toast("验证码发送成功!"),
          () => Toast("获取验证码失败!")
      );
    },

    next() {
      if (this.step > 1) {
        this.newMobile = this.newMobile ? this.newMobile.replace(/ /g, "") : undefined;
        if (!this.newMobile || !this.verificationCode || this.newMobile.length !== 11) {
          Toast("手机号或验证码不能为空!");
          return;
        }
        if (this.step === 3) {
          this.confirmSubmit();
          return;
        }
      }
      if (this.step === 1) {
        if (!this.registerClick) {
          Toast("请先阅读用户注册协议再进行下一步!");
          return;
        }
        if (!this.isClick) {
          Toast("请先下载打印再进行下一步!");
          return;
        }
      }
      this.step++;
      this.dialog = this.getDialog(this.step);
    },

    pre() {
      if (this.step === 1) {
        this.downloadTemplate();
      } else {
        this.step--;
        this.dialog = this.getDialog(this.step);
      }
    },

    confirmSubmit() {
      if (!this.password || !this.confirmPassword) {
        Toast("密码不能为空!");
        return;
      }
      if (this.password !== this.confirmPassword) {
        Toast("确认密码和设置密码不一致!");
        return;
      }
      if (this.password.length < 6) {
        Toast("密码最少6位!");
        return;
      }
      var requestData = {
        mobile: this.newMobile,
        password: this.password,
        verificationCode: this.verificationCode,
      };
      submitMobilePwdVer(
          requestData,
          (d) => {
            Toast(d.data.msg);
            if (d.data.success) {
              setTimeout(() => {
                window.location.href = "http://www.jinyijia1688.com/help/receiptLetter.html";
              }, 1000);
            }
            this.noticeState();
          },
          () => Toast("网络异常,稍后重试")
      );
    },

    countdown() {
      this.showCountdown = true;
      this.countdownNum = 60;
      var i = 60;
      var timer = setInterval(() => {
        this.countdownNum = --i;
        if (i <= 0) {
          this.showCountdown = false;
          clearInterval(timer);
        }
      }, 1000);
    },

    getDialog(step) {
      var dialogs = [
        { title: "激活认证", showConfirm: true, confirmText: "下一步", showCancel: true, cancelText: "复制下载链接" },
        { title: "绑定手机", showConfirm: true, confirmText: "下一步", showCancel: true, cancelText: "上一步" },
        { title: "修改密码", showConfirm: true, confirmText: "确认提交", showCancel: true, cancelText: "上一步" },
      ];
      return dialogs[step - 1];
    },

    downloadTemplate() {
      this.isClick = true;
      this.clipboard("https://m.jinyijia1688.com/file/%E5%A3%B0%E6%98%8E%E5%87%BD.pdf");
      Toast("链接已复制成功 下载并打印");
    },

    clipboard(text) {
      var input = document.createElement("input");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    },

    agreeDialog() {
      Dialog.confirm({
        title: "金怡佳商城注册协议",
        message: '<h5>一、总则</h5><p>注册用户在使用金怡佳商城平台提供的各项服务之前,应仔细阅读本服务协议。如您不同意本服务协议及/或随时对其的修改,您可以主动取消金怡佳商城平台提供的服务；您一旦使用金怡佳商城平台的服务,即视为您已了解并完全同意本服务协议各项内容。</p>',
      });
    },

    validatePassword() {
      if (!this.password) Toast("密码不能为空!");
    },

    validateConfirmPassword() {
      if (!this.confirmPassword) Toast("确认密码不能为空!");
      else if (this.password !== this.confirmPassword) Toast("确认密码和设置密码不一致!");
    },
  },
};
</script>

<style scoped>
/* 轮播指示器 */
#home :deep(.banner-swipe .van-swipe__indicators) {
  bottom: 8px;
}
#home :deep(.banner-swipe .van-swipe__indicator) {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: rgba(255,255,255,0.5);
  transition: all 0.3s;
}
#home :deep(.banner-swipe .van-swipe__indicator--active) {
  width: 16px;
  background: #fff;
}

/* 标签页 */
#home :deep(.product-tabs) {
  background: white;
}
#home :deep(.product-tabs .van-tabs__nav) {
  background: white;
}
#home :deep(.product-tabs .van-tabs__line) {
  background: #e53e3e;
  width: 20px !important;
  height: 3px;
  border-radius: 2px;
}
#home :deep(.product-tabs .van-tab) {
  color: #999;
  font-size: 14px;
}
#home :deep(.product-tabs .van-tab--active) {
  color: #333;
  font-weight: 700;
}

/* 弹窗 */
#home :deep(.van-dialog) {
  border-radius: 12px;
}
#home :deep(.van-dialog__header) {
  font-weight: 600;
  padding-top: 20px;
}
#home :deep(.van-dialog__confirm) {
  background: #e53e3e !important;
  color: white !important;
}

/* 文字截断 */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>